import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { Checkbox, Input } from "uxp/components";
import { hasValue, parseValue } from "../../../../util";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface INumberFieldProperty extends IBaseInputFieldProperty {
	placeholder: string;
	textColor: string;
	backgroundColor: string;
	fontSize: string,
	textAlign: string,
	fieldLabel: IFieldTitleProps,
	allowDecimals?: boolean,
	step?: string
	allowNegativeValues?: boolean,
	minValue?: string,
	maxValue?: string
}

function getMinMax(minValue: string, maxValue: string, allowNegativeValues?: boolean) {
	let min = hasValue(minValue) ? Number(minValue) : undefined
	let max = hasValue(maxValue) ? Number(maxValue) : undefined
	if (allowNegativeValues == false && (minValue == undefined || min < 0)) min = 0
	if (allowNegativeValues == false && (!!maxValue && max < 0)) max = undefined

	return { min, max }
}

function getValue(value: number, min?: number) {
	if (hasValue(value, true, true)) return value.toString()
	return hasValue(min, true, true) ? min.toString() : "0"
}

function formatBeforeChange(value: string, min?: number, max?: number, allowDecimals?: boolean): number {
	console.log('vvvv', value);

	let updatedValue: number = 0
	if (hasValue(value)) {

		if (allowDecimals) updatedValue = parseFloat(value)
		else updatedValue = parseInt(value)

		if (!!min && updatedValue < min) updatedValue = min
		if (!!max && updatedValue > max) updatedValue = max
		console.log('ddd ', updatedValue);
	}
	else updatedValue = hasValue(min, true) ? min : 0
	console.log('final ', updatedValue);

	return updatedValue
}

function getInputAttributes(min?: number, max?: number, step?: string) {
	let inputAttr: any = {}
	if (!!min) inputAttr.min = min
	if (!!max) inputAttr.max = max
	if (hasValue(step)) inputAttr.step = Number(step) || 1

	return inputAttr
}


export const Field: React.FunctionComponent<IUIFieldProps<INumberFieldProperty>> = (props) => {
	let { value, onChange, placeholder, textColor, backgroundColor, fontSize, textAlign, fieldLabel, allowDecimals, step, minValue, maxValue, allowNegativeValues } = props?.fieldProps || {};

	let { min, max } = getMinMax(minValue, maxValue, allowNegativeValues)

	let styles: React.CSSProperties = {}
	if (hasValue(textColor)) styles.color = parseValue(textColor, props.contextData)
	if (hasValue(backgroundColor)) styles.backgroundColor = parseValue(backgroundColor, props.contextData)
	if (hasValue(fontSize)) styles.fontSize = fontSize
	if (hasValue(textAlign)) styles.textAlign = textAlign as any

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<Input
				type="number"
				value={getValue(value)}
				placeholder={placeholder || ''}
				onChange={val => {
					const upd = formatBeforeChange(val, min, max, allowDecimals)
					console.log('updated val ', upd);

					onChange(upd)
				}}
				styles={styles}
				inputAttr={getInputAttributes(min, max, step)}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<INumberFieldProperty>> = (props) => {
	let { value, onChange, placeholder, textColor, backgroundColor, fontSize, textAlign, fieldLabel, allowDecimals, step, minValue, maxValue, allowNegativeValues } = props.uiProps || {};
	let { min, max } = getMinMax(minValue, maxValue, allowNegativeValues)

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Number Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<Input
					type="number"
					value={getValue(value)}
					onChange={s => {
						let val = formatBeforeChange(s, min, max, allowDecimals)
						props.onChange(Object.assign({}, props.uiProps, { value: val }))
					}}
					inputAttr={getInputAttributes(min, max, step)}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Placeholder</PropertyTitle>
				<Input
					value={props.uiProps.placeholder || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { placeholder: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Step (increase/decrease value by)</PropertyTitle>
				<Input
					value={step || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { step: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Min value </PropertyTitle>
				<Input
					value={minValue || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { minValue: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Max value</PropertyTitle>
				<Input
					value={maxValue || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { maxValue: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<Checkbox
					checked={allowDecimals}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { allowDecimals: s }))}
					label="Allow decimal values"
				/>
			</Property>

			<Property>
				<Checkbox
					checked={allowNegativeValues}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { allowNegativeValues: s }))}
					label="Allow negative values"
				/>
			</Property>


			{/* <Property>
				<PropertyTitle>Text Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.textColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textColor: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Align</PropertyTitle>
				<TextAlignEditor
					value={props.uiProps.textAlign || 'left'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textAlign: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Background Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.backgroundColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { backgroundColor: s }))}
				/>
			</Property> */}

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'number',
	category: 'inputs',
	description: 'Number Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		placeholder: 'Enter some value',
		backgroundColor: '',
		textColor: '',
		fontSize: '12px',
		textAlign: 'left',
		fieldLabel: {
			label: 'Number Label',
		},
	},
	type:'number'

});
